import React from 'react'

const OnBoarding = () => {
  return (
    <div>OnBoarding</div>
  )
}

export default OnBoarding